// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.108.4/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.108.4/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.leadsRow {
  cursor: pointer;
}

.monthlyTask {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.monthlyTask .taskInfo {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
}
.monthlyTask .taskInfo .taskTitle {
  color: #434243;
  font-size: 14px;
  font-weight: 500;
  margin: 0;
}
.monthlyTask .taskInfo .taskType {
  margin: 0;
  margin-top: 4px;
  color: #757575;
  font-size: 12px;
  font-weight: 400;
}
.monthlyTask .taskValue {
  display: flex;
  color: #434243;
  font-family: Roboto;
  font-size: 14px;
  font-weight: 500;
  margin: 0;
}
.monthlyTask .company {
  display: flex;
  width: 32px;
  height: 32px;
  padding: 8px 11px;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  background: #e9e7f2;
  margin-right: 16px;
}

.TasksTable .nameAndLogo,
.CustomersTable .nameAndLogo {
  display: flex;
  align-items: center;
}
.TasksTable .nameAndLogo p,
.CustomersTable .nameAndLogo p {
  margin: 0;
}
.TasksTable .nameAndLogo img,
.CustomersTable .nameAndLogo img {
  margin-right: 10px;
  border-radius: 5px;
}
.TasksTable .nameAndLogo p,
.TasksTable .jobType p,
.CustomersTable .nameAndLogo p,
.CustomersTable .jobType p {
  margin: 0;
}
.TasksTable .image-card img,
.CustomersTable .image-card img {
  border-radius: 10px;
}
.TasksTable .showFilesInvoice,
.CustomersTable .showFilesInvoice {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 5%;
}
.TasksTable .fileCont,
.CustomersTable .fileCont {
  position: relative;
}
.TasksTable .css-teccuw-MuiToolbar-root-MuiTablePagination-toolbar,
.CustomersTable .css-teccuw-MuiToolbar-root-MuiTablePagination-toolbar {
  align-items: baseline;
}
.TasksTable .status,
.CustomersTable .status {
  display: flex;
  align-items: center;
}
.TasksTable .status .space,
.CustomersTable .status .space {
  margin-right: 5px;
}

.EnhancedTableToolbar .sortAndFilters {
  display: flex;
  justify-content: flex-end;
}

.filterDrawer .drawerContainer {
  width: 20vw;
  min-width: 230px;
  margin-top: 60%;
}
.filterDrawer .drawerContainer .header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.filterDrawer .drawerContainer form > div {
  margin-top: 20px;
}
.filterDrawer .drawerContainer .clearButt {
  margin-top: 20px;
  height: 3.5em;
}

@media (max-width: 768px) {
  * {
    font-size: 10px;
  }
}
.sortby {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 5px;
  width: fit-content;
  text-align: center;
  border-right: solid rgba(161, 158, 158, 0.5) 1px;
  border-left: solid rgba(161, 158, 158, 0.5) 1px;
}
.sortby label {
  margin-right: 10px;
  margin-left: 10px;
}
.sortby .css-1jewp7z-MuiInputBase-root-MuiInput-root-MuiSelect-root:before {
  border-bottom: none;
}
.sortby #demo-simple-select {
  margin-top: 3px;
}

.removeIcon {
  cursor: pointer;
  transition: transform 0.2s;
}
.removeIcon:hover {
  transform: scale(1.2);
}
.removeIcon:active {
  transform: scale(0.9);
}

.css-cl7x3o-MuiInputBase-root-MuiInput-root-MuiSelect-root:before {
  border-bottom: none;
}

.searchBy {
  border-left: none;
}`, "",{"version":3,"sources":["webpack://./src/components/TableRender/styles.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;AACF;;AAEA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AACF;AAAE;EACE,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,uBAAA;EACA,WAAA;AAEJ;AADI;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,SAAA;AAGN;AADI;EACE,SAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAGN;AAAE;EACE,aAAA;EACA,cAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,SAAA;AAEJ;AAAE;EACE,aAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;AAEJ;;AAUE;;EACE,aAAA;EACA,mBAAA;AANJ;AAOI;;EACE,SAAA;AAJN;AAMI;;EACE,kBAAA;EACA,kBAAA;AAHN;AASI;;;;EACE,SAAA;AAJN;AAQE;;EACE,mBAAA;AALJ;AAQE;;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;AALJ;AAQE;;EACE,kBAAA;AALJ;AAQE;;EACE,qBAAA;AALJ;AAQE;;EACE,aAAA;EACA,mBAAA;AALJ;AAMI;;EACE,iBAAA;AAHN;;AASE;EACE,aAAA;EACA,yBAAA;AANJ;;AAWE;EAME,WAAA;EACA,gBAAA;EACA,eAAA;AAbJ;AAMI;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AAJN;AASI;EACE,gBAAA;AAPN;AASI;EACE,gBAAA;EACA,aAAA;AAPN;;AAYA;EACE;IACE,eAAA;EATF;AACF;AAWA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EAEA,eAAA;EACA,kBAAA;EACA,kBAAA;EAEA,gDAhGW;EAiGX,+CAjGW;AAsFb;AAaE;EACE,kBAAA;EACA,iBAAA;AAXJ;AAaE;EACE,mBAAA;AAXJ;AAaE;EACE,eAAA;AAXJ;;AAeA;EACE,eAAA;EACA,0BAAA;AAZF;AAaE;EACE,qBAAA;AAXJ;AAaE;EACE,qBAAA;AAXJ;;AAeA;EACE,mBAAA;AAZF;;AAcA;EACE,iBAAA;AAXF","sourcesContent":[".leadsRow {\n  cursor: pointer;\n}\n\n.monthlyTask {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  .taskInfo {\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n    align-items: flex-start;\n    width: 100%;\n    .taskTitle {\n      color: #434243;\n      font-size: 14px;\n      font-weight: 500;\n      margin: 0;\n    }\n    .taskType {\n      margin: 0;\n      margin-top: 4px;\n      color: #757575;\n      font-size: 12px;\n      font-weight: 400;\n    }\n  }\n  .taskValue {\n    display: flex;\n    color: #434243;\n    font-family: Roboto;\n    font-size: 14px;\n    font-weight: 500;\n    margin: 0;\n  }\n  .company {\n    display: flex;\n    width: 32px;\n    height: 32px;\n    padding: 8px 11px;\n    justify-content: center;\n    align-items: center;\n    border-radius: 4px;\n    background: #e9e7f2;\n    margin-right: 16px;\n  }\n}\n\n$borderSide: solid\n  rgba(\n    $color: #a19e9e,\n    $alpha: 0.5,\n  )\n  1px;\n.TasksTable,\n.CustomersTable {\n  .nameAndLogo {\n    display: flex;\n    align-items: center;\n    p {\n      margin: 0;\n    }\n    img {\n      margin-right: 10px;\n      border-radius: 5px;\n    }\n  }\n\n  .nameAndLogo,\n  .jobType {\n    p {\n      margin: 0;\n    }\n  }\n\n  .image-card img {\n    border-radius: 10px;\n  }\n\n  .showFilesInvoice {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-top: 5%;\n  }\n\n  .fileCont {\n    position: relative;\n  }\n\n  .css-teccuw-MuiToolbar-root-MuiTablePagination-toolbar {\n    align-items: baseline;\n  }\n\n  .status {\n    display: flex;\n    align-items: center;\n    .space {\n      margin-right: 5px;\n    }\n  }\n}\n\n.EnhancedTableToolbar {\n  .sortAndFilters {\n    display: flex;\n    justify-content: flex-end;\n  }\n}\n\n.filterDrawer {\n  .drawerContainer {\n    .header {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n    }\n    width: 20vw;\n    min-width: 230px;\n    margin-top: 60%;\n    form > div {\n      margin-top: 20px;\n    }\n    .clearButt {\n      margin-top: 20px;\n      height: 3.5em;\n    }\n  }\n}\n\n@media (max-width: 768px) {\n  * {\n    font-size: 10px;\n  }\n}\n.sortby {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  margin-top: 5px;\n  width: fit-content;\n  text-align: center;\n\n  border-right: $borderSide;\n  border-left: $borderSide;\n\n  label {\n    margin-right: 10px;\n    margin-left: 10px;\n  }\n  .css-1jewp7z-MuiInputBase-root-MuiInput-root-MuiSelect-root:before {\n    border-bottom: none;\n  }\n  #demo-simple-select {\n    margin-top: 3px;\n  }\n}\n\n.removeIcon {\n  cursor: pointer;\n  transition: transform 0.2s;\n  &:hover {\n    transform: scale(1.2);\n  }\n  &:active {\n    transform: scale(0.9);\n  }\n}\n\n.css-cl7x3o-MuiInputBase-root-MuiInput-root-MuiSelect-root:before {\n  border-bottom: none;\n}\n.searchBy {\n  border-left: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
